/* ==========================================================================
   GODIAG 改版 · 详情页图库
   --------------------------------------------------------------------------
   刻意只做一件事：点缩略图换主图。

   【不做】自动轮播——两三千美元的决策型商品，图自己在动的话
   看不完也点不准，而且会把用户没选的内容强行推走。

   规格切换后的换图走原厂 pubsub（feature-detect，拿不到就安静跳过），
   不自己去监听 select 的 change：那样会和 global.js 的 VariantSelects
   抢同一个事件，输的那个被静默覆盖——前任在 YMM 搜索按钮上
   已经踩过一次这个坑（用 stopImmediatePropagation 强压另一个处理器）。
   ========================================================================== */
(function () {
  'use strict';

  var gal = document.querySelector('[data-pdp-gal]');
  if (!gal) return;

  var main = gal.querySelector('[data-pdp-main]');
  var thumbs = [].slice.call(gal.querySelectorAll('[data-pdp-thumb]'));
  if (!main) return;

  function show(src, alt, btn, zoom) {
    if (!src || main.getAttribute('src') === src) return;
    main.setAttribute('src', src);
    main.setAttribute('data-zoom', zoom || src);
    // srcset 里还是旧图的候选，不清掉浏览器会挑回原来那张
    main.removeAttribute('srcset');
    if (alt) main.setAttribute('alt', alt);
    thumbs.forEach(function (t) { t.classList.toggle('is-on', t === btn); });
  }

  thumbs.forEach(function (btn) {
    btn.addEventListener('click', function () {
      show(btn.getAttribute('data-full'), btn.getAttribute('data-alt'), btn, btn.getAttribute('data-zoom'));
    });
  });

  /* 换规格时跟着换图。原厂 VariantSelects 换完价格/SKU/库存后会 publish
     一个 variantChange 事件，里面带 variant 对象。subscribe 和
     PUB_SUB_EVENTS 都是 pubsub.js 里的全局函数——但主题不保证每个模板
     都载入它，所以这里先探测再用，探测不到就只是少了这个便利功能，
     不会抛错也不影响加购。 */
  try {
    if (typeof subscribe === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (e) {
        var img = e && e.data && e.data.variant && e.data.variant.featured_image;
        if (!img || !img.src) return;
        // variant.featured_image.src 不带尺寸参数，补一个避免拉原图
        var src = img.src.indexOf('?') > -1 ? img.src : img.src + '?width=1600';
        show(src, img.alt, null);
      });
    }
  } catch (err) { /* 探测失败就算了，图库退化成纯手动，不影响购买 */ }

  /* ==========================================================================
     2026-09-28 第二轮 · 放大镜 + 全屏大图
     甲方：笔记本上看不清图（她给了浏览器 100% / 50% 两张截图）。
     · 桌面（精确指针）：鼠标移到主图上就地放大 2.2 倍，放大中心跟着鼠标走。
       高清图（2400px）到【第一次悬停】才加载，不拖慢首屏。
     · 点击 / 手机轻点 / 右上角放大按钮：打开全屏大图，手机上可以双指放大。
     · 不做自动轮播、不劫持滚轮——这是看细节，不是看动画。
     ========================================================================== */
  var area = gal.querySelector('[data-pdp-zoom-area]');
  var openBtn = gal.querySelector('[data-pdp-zoom-open]');
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var ZOOM = 2.2;

  if (area) {
    var hiLoaded = '';
    area.addEventListener('mousemove', function (e) {
      if (!fine.matches) return;
      var r = area.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width) * 100;
      var y = ((e.clientY - r.top) / r.height) * 100;
      var hi = main.getAttribute('data-zoom');
      if (hi && hiLoaded !== hi) {
        hiLoaded = hi;
        main.removeAttribute('srcset');
        main.setAttribute('src', hi);
      }
      main.style.transformOrigin = x + '% ' + y + '%';
      area.classList.add('is-zooming');
    });
    area.addEventListener('mouseleave', function () {
      area.classList.remove('is-zooming');
      main.style.transformOrigin = '';
    });
    area.addEventListener('click', function (e) {
      if (e.target.closest('[data-pdp-zoom-open]')) return;
      openBox();
    });
  }
  if (openBtn) openBtn.addEventListener('click', function (e) { e.stopPropagation(); openBox(); });

  var box = null, lastFocus = null;
  function closeBox() {
    if (!box) return;
    box.remove(); box = null;
    document.documentElement.classList.remove('pdp-box-open');
    if (lastFocus) lastFocus.focus();
  }
  function openBox() {
    if (box) return;
    lastFocus = document.activeElement;
    box = document.createElement('div');
    box.className = 'pdp-box';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', main.getAttribute('alt') || '');
    var img = document.createElement('img');
    img.src = main.getAttribute('data-zoom') || main.getAttribute('src');
    img.alt = main.getAttribute('alt') || '';
    var x = document.createElement('button');
    x.type = 'button'; x.className = 'pdp-box__x';
    x.setAttribute('aria-label', 'Close'); x.innerHTML = '&times;';
    x.addEventListener('click', closeBox);
    box.addEventListener('click', function (e) { if (e.target === box) closeBox(); });
    box.appendChild(img); box.appendChild(x);
    document.body.appendChild(box);
    document.documentElement.classList.add('pdp-box-open');
    x.focus();
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeBox(); });

})();

/* Buy it now 单独一个作用域：上面图库那段在商品没有图时会提前 return，
   按钮不能跟着失效。 */
(function () {
  'use strict';
  /* ==========================================================================
     2026-09-28 第二轮 · Buy it now
     用 Shopify 购物车直链 /cart/{规格ID}:{数量}：新建一张只有这一件的结账单直接跳过去，
     和原生 Buy it now 同一个语义，购物车里原有的东西不动。
     规格 id 从表单的 name="id" 实时读——换规格时原厂 VariantSelects 会改它。
     缺货状态跟着加购按钮走：原厂换规格时只会禁用加购按钮，这里观察它、同步过来。
     ========================================================================== */
  var now = document.querySelector('[data-pdp-now]');
  if (now) {
    var form = now.closest('form');
    var atc = form && form.querySelector('[name="add"]');
    now.addEventListener('click', function () {
      if (!form || now.disabled) return;
      var idEl = form.querySelector('[name="id"]');
      var qEl = document.querySelector('.pdp__q [name="quantity"]') || form.querySelector('[name="quantity"]');
      var id = idEl && idEl.value;
      var q = Math.max(1, parseInt(qEl && qEl.value, 10) || 1);
      if (!id || (idEl && idEl.disabled)) return;
      now.setAttribute('aria-busy', 'true');
      window.location.href = '/cart/' + encodeURIComponent(id) + ':' + q;
    });
    if (atc && 'MutationObserver' in window) {
      var mirror = function () { now.disabled = atc.disabled; };
      new MutationObserver(mirror).observe(atc, { attributes: true, attributeFilter: ['disabled'] });
      mirror();
    }
  }
})();
